import script from "./UpdateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateModal.vue?vue&type=script&setup=true&lang=js"

import "./UpdateModal.vue?vue&type=style&index=0&id=34c32bab&lang=css"

const __exports__ = script;

export default __exports__